import { useEffect, useState } from "react";
import "../../src/Loogin.css";
import "../App.css";
import DateTime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from "moment";

const LoginForm = ({ storedDob, otpSend, displayOtpForm, phoneNumber, displayLoader }: any) => {

  const [dob, setDob] = useState<moment.Moment>();
  const [dobError, setDobError] = useState('');
  const inputProps = {
    placeholder: "DD/MM/YYYY"
  }

  const handleLogin = async () => {
    let formattedDate = dob?.format('YYYY-MM-DD');
    if (formattedDate == storedDob) {
      displayLoader(true);
      const otpResponse: any = await otpSend();
      displayLoader(false);
      if (otpResponse?.success) {
        displayOtpForm(true);
      } else if (otpResponse?.error) {
        //handle error
        if(otpResponse?.error?.code == 'ERR026') {
          setDobError("You have exceeded your limit to send OTP. Please try again later.");
        }
      }

    } else {
      //dob not match handle error
      setDobError("Date of Birth Does not match");
    }
  };
  return (
    <div className="boxS">
      <p className='phoneNumber'>Phone Number :</p><p>{'+91 ' + phoneNumber?.substring(0, 2) + 'XXXXXX' + phoneNumber?.substring(8)}</p>
      <p className='inputLabel'>Date of Birth</p>
      <DateTime
        inputProps = {inputProps}
        dateFormat="DD/MM/YYYY"
        timeFormat={false}
        onChange={(date: any) => {setDob(date)}}
        closeOnSelect={true}
        value={dob}
        />
      <p className="errorText">{dobError || <span>&nbsp;&nbsp;</span>}</p>
      <button onClick={handleLogin}>Submit</button>
    </div>

  )
}

export default LoginForm;